// extracted by mini-css-extract-plugin
export default {"dividerContainer":"a_LSRh","vertical":"kGilCU","horizontal":"e_rEaU","orText":"pAikFK","line":"F4ict6","withMargin":"fCfZ_1","form":"eRshcL","subtitle":"An0HPm"};